import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { SignIn, SignUp } from './lib/auth';
import RootLayout from './components/layout/RootLayout';
import ClerkTokenBridge from './components/layout/ClerkTokenBridge';
import ProtectedRoute from './components/layout/ProtectedRoute';
import HomePage from './pages/HomePage';
import SearchResultsPage from './pages/SearchResultsPage';
import PropertyDetailPage from './pages/PropertyDetailPage';
import MessagesPage from './pages/MessagesPage';
import MyListingsPage from './pages/MyListingsPage';
import CreateListingPage from './pages/CreateListingPage';
import FavoritesPage from './pages/FavoritesPage';
import ProfilePage from './pages/ProfilePage';
import BookingSuccessPage from './pages/BookingSuccessPage';
import NotFoundPage from './pages/NotFoundPage';

const AdminApp = lazy(() => import('./admin'));

export default function App() {
  return (
    <>
      <ClerkTokenBridge />
      <Routes>
        {/* Admin panel has its own layout (sidebar), outside the public navbar/footer. */}
        <Route
          path="/admin/*"
          element={
            <Suspense fallback={<div className="min-h-screen bg-cream-100" />}>
              <AdminApp />
            </Suspense>
          }
        />
        <Route element={<RootLayout />}>
          <Route index element={<HomePage />} />
          <Route path="/ara" element={<SearchResultsPage />} />
          <Route path="/mulk/:slug" element={<PropertyDetailPage />} />
          <Route path="/rezervasyon/:id/basarili" element={<BookingSuccessPage />} />

          <Route
            path="/mesajlar"
            element={<ProtectedRoute><MessagesPage /></ProtectedRoute>}
          />
          <Route
            path="/mesajlar/:conversationId"
            element={<ProtectedRoute><MessagesPage /></ProtectedRoute>}
          />
          <Route
            path="/ilanlarim"
            element={<ProtectedRoute><MyListingsPage /></ProtectedRoute>}
          />
          <Route
            path="/ilanlarim/yeni"
            element={<ProtectedRoute><CreateListingPage /></ProtectedRoute>}
          />
          <Route
            path="/favoriler"
            element={<ProtectedRoute><FavoritesPage /></ProtectedRoute>}
          />
          <Route
            path="/profil"
            element={<ProtectedRoute><ProfilePage /></ProtectedRoute>}
          />

          <Route path="/giris/*" element={<AuthShell><SignIn routing="path" path="/giris" signUpUrl="/kayit" /></AuthShell>} />
          <Route path="/kayit/*" element={<AuthShell><SignUp routing="path" path="/kayit" signInUrl="/giris" /></AuthShell>} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </>
  );
}

function AuthShell({ children }: { children: React.ReactNode }) {
  return <div className="flex min-h-[70vh] items-center justify-center px-4 py-12">{children}</div>;
}
